<template>
  <main>
    <!-- Start Banner -->
    <div class="banner technology">
      <div class="container custom">
        <div class="banner__content">
          <div class="banner__box">
            <div class="banner__box-item" data-aos="fade-up">
              <div class="item__title">Technology</div>
              <div class="item__content">TimeBird provides a FinTech ecosystem which can be customized to customer’s own needs, proposes solutions to help customers effectively manage production and business activities, as well as provides consulting and training services, specialized in the field of fintech.</div>
            </div>
            <div class="banner__box-item" data-aos="fade" data-aos-delay="500">
              <div class="item__image">
                <img src="/assets/images/technology/technology-image.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner -->
    <!-- Start Technology -->
    <div class="section technology">
      <div class="container custom">
        <div class="section__tab" data-aos="fade-up">
          <div class="section__tab-item" :class="{ active: activeTab === 'stack' }" @click="showTab('stack')">Stack</div>
          <div class="section__tab-item" :class="{ active: activeTab === 'blockchain' }" @click="showTab('blockchain')">Blockchain</div>
          <div class="section__tab-item" :class="{ active: activeTab === 'ai' }" @click="showTab('ai')">AI</div>
        </div>
        <div class="section__content" data-aos="fade" data-aos-delay="500">
          <div class="section__content-box" :class="{ show: activeTab === 'stack' }">
            <div class="box__item" v-for="(item, index) in listStack" :key="index">
              <div class="box__item-image">
                <img :src="`/assets/images/technology/${item.image}.png`" :alt="item.image">
              </div>
              <div class="box__item-title">{{ item.title }}</div>
            </div>
          </div>
          <div class="section__content-box" :class="{ show: activeTab === 'blockchain' }">
            <div class="box__item" v-for="(item, index) in listBlockchain" :key="index">
              <div class="box__item-image">
                <img :src="`/assets/images/technology/${item.image}.png`" :alt="item.image">
              </div>
              <div class="box__item-title">{{ item.title }}</div>
            </div>
          </div>
          <div class="section__content-box" :class="{ show: activeTab === 'ai' }">
            <div class="box__item" v-for="(item, index) in listAI" :key="index">
              <div class="box__item-image">
                <img :src="`/assets/images/technology/${item.image}.png`" :alt="item.image">
              </div>
              <div class="box__item-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Technology -->
  </main>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 'stack',
      listStack: [
        { image: 'spring', title: 'Spring' },
        { image: 'vertx', title: 'VertX' },
        { image: 'nodejs', title: 'NodeJS' },
        { image: 'karfka', title: 'Karfka' },
        { image: 'sql', title: 'SQL' },
        { image: 'mongodb', title: 'MongoDB' },
        { image: 'redis', title: 'Redis' },
        { image: 'memcache', title: 'Memcache' },
        { image: 'vuejs', title: 'VueJS' },
        { image: 'reactjs', title: 'ReactJs' },
        { image: 'flutter', title: 'Flutter' },
        { image: 'swift', title: 'Swift' },
        { image: 'java', title: 'Java' },
        { image: 'openstack', title: 'Openstack' },
        { image: 'docker', title: 'Docker' },
        { image: 'kubernetes', title: 'Kubernetes' },
        { image: 'ec2', title: 'EC2' },
        { image: 'aws-service-01', title: 'Aws service (S3)' },
        { image: 'aws-service-02', title: 'Aws service (Cloudfront)' },
        { image: 'aws-service-03', title: 'Aws service (Route 53)' },
      ],
      listBlockchain: [
        { image: 'eth', title: 'Ethereum' },
        { image: 'btc', title: 'Bitcoin' },
        { image: 'trx', title: 'TRON' },
        { image: 'binance', title: 'BNB chain' },
        { image: 'waves', title: 'WAVES' },
        { image: 'near', title: 'NEAR Protocol' },
        { image: 'sol', title: 'Solana' },
        { image: 'bnb', title: 'BSC' },
        { image: 'dot', title: 'Polkadot' },
        { image: 'avax', title: 'Avalanche' },
        { image: 'matic', title: 'Polygon' },
        { image: 'xlm', title: 'Stellar' },
        { image: 'algo', title: 'Algorand' },
        { image: 'eos', title: 'EOS' },
        { image: 'atom', title: 'Cosmos' },
        { image: 'theta', title: 'THETA' },
        { image: 'vet', title: 'Vechain Thor' },
        { image: 'ftm', title: 'Fantom Opera' },
        { image: 'egld', title: 'Elrond Network' },
        { image: 'luna', title: 'Terra' },
      ],
      listAI: [
        { image: 'ocr', title: 'OCR' },
        { image: 'validation', title: 'Validation' },
        { image: 'face-anti-spoofing', title: 'Face anti spoofing' },
        { image: 'face', title: 'Face verification' },
        { image: 'nlp', title: 'NLP' },
      ],
    }
  },
  methods: {
    showTab(item) {
      this.activeTab = item
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>